import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { KTSVG } from '../../../../_metronic/helpers'
import { FormattedMessage } from 'react-intl'
import dayjs from 'dayjs'
import { Reseller } from '../resellers-list/core/_models'

type Props = {
    isResellerLoading: boolean
    reseller: Reseller | undefined
    subResellers: Reseller[] // Add subResellers to Props
}

export const ResellerView: React.FC<Props> = ({ reseller, isResellerLoading, subResellers }) => {
    const params = useParams<{ id: string }>()
    return (
        <>
            <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
                <div className='card-header cursor-pointer'>
                    <div className='card-title m-0'>
                        <h3 className='fw-bolder m-0'>
                            <FormattedMessage id='RESELLER.VIEW.SUBRESELLERSLIST' />
                        </h3>
                    </div>
                </div>

                <div className='card-body p-9'>
                    {/* Display all sub-resellers of this reseller */}
                    <ul className='list-group'>
                        {subResellers.length > 0 ? (
                            subResellers.map((subReseller) => (
                                <li key={subReseller.id} className='list-group-item'>
                                    <Link to={`/admin/pages/resellers/view/${subReseller.id}`}>
                                        {subReseller.reseller_name}
                                    </Link>
                                </li>
                            ))
                        ) : (
                            <p>No sub-resellers found.</p>
                        )}
                    </ul>
                </div>
            </div>

           
        </>
    )
}
